export default {
  START_DATE_LOWER_THAN_CURRENT_DATE: "تاریخ شروع قبل از تاریخ جاری است.",
  END_DATE_LOWER_THAN_START_DATE: "تاریخ پایان قبل از تاریخ شروع است.",
};
